import Vue from 'vue'
import Vuex from 'vuex'
// import { createLogger } from 'vuex/dist/logger'

import vuexPersistedstate from 'vuex-persistedstate'

import app from './modules/app'
import auth from './modules/auth'
import demarcacion from './modules/demarcacion'
import dispositivo from './modules/dispositivo'
import emergencia from './modules/emergencia'
import icono from './modules/icono'
import incendio from './modules/incendio'
import informe from './modules/informe'
import infraestructura from './modules/infraestructura'
import map from './modules/map'
import medioPersonal from './modules/medioPersonal'
import organismo from './modules/organismo'
import parametro from './modules/parametro'
import planificacion from './modules/planificacion'
import recurso from './modules/recurso'
import recursoCategoria from './modules/recursoCategoria'
import recursoClase from './modules/recursoClase'
import recursoRecursoTipo from './modules/recursoRecursoTipo'
import recursoSector from './modules/recursoSector'
import recursoTipo from './modules/recursoTipo'
import shareMap from './modules/shareMap'
import simulacion from './modules/simulacion'
import tituloProfesional from './modules/tituloProfesional'
import usuario from './modules/usuario'
import webmap from './modules/webmap'
import rol from './modules/rol'
import permiso from './modules/permiso'
import layer from './modules/layer'
import notifications from './plugins/notifications'
import emergenciaPlugin from './plugins/emergencia.plugin'
import geofencing from './modules/geofencing'
import leftMenu from './modules/leftMenu'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const persistedState = vuexPersistedstate({
  key: 'murcia-wildfire-state',
  reducer: state => {
    const { sync: _sync, ...persistedUsuario } = state.usuario

    return {
      auth: state.auth,
      usuario: persistedUsuario
    }
  }
})

export default new Vuex.Store({
  modules: {
    app,
    auth,
    map,
    shareMap,

    incendio,
    recurso,
    parametro,
    usuario,
    webmap,
    rol,
    permiso,
    planificacion,
    simulacion,
    medioPersonal,
    infraestructura,
    informe,
    recursoRecursoTipo,
    recursoCategoria,
    demarcacion,
    recursoSector,
    tituloProfesional,
    recursoTipo,
    organismo,
    emergencia,
    dispositivo,
    recursoClase,
    layer,
    geofencing,
    icono,
    leftMenu
  },
  plugins: [persistedState, notifications, emergenciaPlugin],
  strict: debug
})
